'use client'

import PropTypes from 'prop-types'
import MUIAvatar from '@mui/material/Avatar'
import MUITooltip from '@mui/material/Tooltip'
import { stringToColor } from '@repo/utils/stringToColor'
import { useFeeEarnerStore } from '@repo/store/useFeeEarnerStore'

export const Avatar = ({
  sx,
  src,
  feeEarnerId,
  initials,
  name,
  size = '40px',
  fontSize = '0.75rem',
  avatarSx = {},
  tooltipProps = { placement: 'right', arrow: true },
  tooltipText,
  children
}) => {
  const { feeEarnersById } = useFeeEarnerStore()
  const textToDisplay = getTextToDisplay(initials, name, feeEarnerId, feeEarnersById)

  const backgroundColor = stringToColor(textToDisplay)

  return (
    <MUITooltip title={tooltipText || name || ''} {...tooltipProps}>
      <MUIAvatar
        data-testid="avatar"
        alt={name}
        src={src}
        sx={{ width: size, height: size, fontSize, backgroundColor, ...avatarSx, ...sx }}
      >
        {src ? null : textToDisplay || children || null}
      </MUIAvatar>
    </MUITooltip>
  )
}

const getTextToDisplay = (initials, name, feeEarnerId, feeEarnersById) => {
  let textToDisplay = ''
  if (initials) textToDisplay = initials

  if (!textToDisplay && feeEarnerId && feeEarnersById?.[feeEarnerId]?.initials) {
    textToDisplay = feeEarnersById[feeEarnerId].initials
  }

  if (!textToDisplay && name && typeof name !== 'object')
    textToDisplay = name
      .split(' ')
      .map((word) => word[0])
      .join('')

  return textToDisplay.slice(0, 3).toUpperCase()
}

Avatar.propTypes = {
  sx: PropTypes.object,
  src: PropTypes.object,
  feeEarnerId: PropTypes.string,
  initials: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.string,
  fontSize: PropTypes.string,
  avatarSx: PropTypes.object,
  tooltipProps: PropTypes.object,
  tooltipText: PropTypes.string,
  children: PropTypes.node
}
